<template>
  <div v-if="visible" class="modal-overlay-mobile">
    <div class="modal-container-mobile" :class="{ 'menu-open': sideMenuOpen }">

      <!-- 좌측 사이드 메뉴 영역 (70vw) -->
      <div class="menu-wrapper" v-show="sideMenuOpen">
        <MobileSideMenu
            :missions="missions"
            @select="handlePromptSelect"
            @close="sideMenuOpen = false"
        />
      </div>

      <!-- 우측 메인 실습 UI 영역 (기존 내용) -->
      <div class="content-wrapper" @click="sideMenuOpen && handelContentClick()">
        <div class="modal-header-mobile">
          <button class="hamburger" @click.stop="sideMenuOpen = true">≡</button>
          <h3>AI 리터러시</h3>
          <button class="close-button" @click="handleClose">×</button>
        </div>

        <div class="mission-panel-mobile">
          <div class="mission-tabs-mobile">
            <label v-for="(mission, i) in missions"
                   :key="i"
                   :class="{'selected':selectedMissionIndex === i}"
                   @click="toggleMission(i)">
<!--              <input type="radio" name="mission" :value="i" v-model="selectedMissionIndex" />-->
              {{ mission.title }}
            </label>
          </div>
          <div v-if="currentMission" class="mission-desc-mobile">
            <p><strong>설명:</strong> {{ currentMission.description }}</p>
            <p><strong>예시 프롬프트:</strong> <code>{{ currentMission.examplePrompt }}</code></p>
            <button
                class="example-prompt-btn"
                :class="{ selected: selectedMissionIndex !== null }"
                @click="applyExamplePrompt"
            >예시 프롬프트 사용</button>
          </div>
        </div>

        <div class="chat-panel-mobile">
          <div class="chat-scrollable" ref="chatContainer">
            <div class="chat-container-mobile" >
              <div
                  v-for="(message, index) in messages"
                  :key="index"
                  :class="['message', message.role]">
                <div class="message-content" v-html="message.content"></div>
              </div>
              <div v-if="isLoading" class="message assistant">
                <div class="message-content">
                 <span class="typing">
                   응답 생성 중<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
                 </span>
                </div>
              </div>
            </div>
           </div>
        </div>

        <div class="input-container-mobile">
         <textarea
             v-model="userInput"
             placeholder="예시 프롬프트를 사용하시거나 배운 내용을 토대로 질문을 입력해보세요! (개인 정보 또는 회사 내부 정보 입력 시 정보보호 정책에 따라 제재를 받을 수 있습니다!)"
             @keydown.enter="handleTextareaEnter"
             @input="handleInput"
             ref="textarea"
             :disabled="isLoading"
             maxlength="1000"
         ></textarea>
          <div :class="['character-count' , {'near-limit': userInput.length > 900}]">
            {{userInput.length}}/1000
          </div>
          <div class="button-group-mobile">
            <button
                class="submit-button"
                @click="handleSubmit"
                :disabled="isLoading || !userInput.trim()"
            >
              {{ isLoading ? '처리중...' : '입력' }}
            </button>
            <button
                class="complete-button"
                @click="handleClose"
                :disabled="isLoading || messages.length === 0"
            >
              실습 완료
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>



<script setup>
import { ref, watch, computed, nextTick, onMounted, onUnmounted} from 'vue';
import ApiService from '@/assets/js/api.service';
import { defineProps, defineEmits } from 'vue';
import { useStore} from 'vuex'
import MobileSideMenu from './MobileSideMenu.vue'


const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  practicePoint: {
    type: Object,
    required : true
  },
  time: {
    type:Array,
    default: () => []
  }
});

const missions = [
  {
    title: '역할 기반 프롬프트',
    description: 'AI에게 특정 직무나 전문가 역할을 부여해 전문적인 관점에서 응답하도록 합니다.',
    examplePrompt: '당신은 은행의 이상거래 탐지 담당자입니다.\n'+ '최근 특정 계좌에서 단기간에 고액의 입출금이 반복되었습니다.\n'+'상급자에게 보고할 내용을 정리해 주세요.'
  },
  {
    title: '제로샷 프롬프트',
    description: '사전 맥락 없이 질문을 직접적으로 던져 AI의 일반 지식과 패턴 학습 기반 응답을 확인합니다.',
    examplePrompt: '은행 영업점과 본부부서에서 AI를 업무에 어떻게 활용할 수 있을까?\n' +'비용절감 및 업무효율화 관점에서 알려줘'
  },
  {
    title: '원샷 / 퓨샷 프롬프트',
    description: '입출력 예시(1개 또는 복수)를 제공하여 AI가 패턴을 학습한 뒤 그에 맞춰 응답하도록 유도합니다.',
    examplePrompt: '다음은 은행 상품에 대한 간단한 설명 예시입니다.\n' +
        '\n' +
        '[예시1]\n' +
        '상품명: 정기예금\n' +
        '설명: 일정 기간 동안 자금을 예치하고 약정된 이자를 받는 안정적인 예금 상품입니다.\n' +
        '[예시2]\n' +
        '상품명: MMDA\n' +
        '설명: 수시 입출금이 가능하면서도 일정 조건을 만족하면 이자가 제공되는 자유로운 예금 상품입니다.\n' +
        '[예시3]\n' +
        '상품명: 주택청약종합저축\n' +
        '설명: 주택 청약을 위한 전용 통장으로, 가입 기간과 납입 금액에 따라 청약 자격이 부여됩니다.\n' +
        '[예시4]\n' +
        '상품명: 적금\n' +
        '→ 설명을 작성해줘\n'
  },
  // {
  //   title: '원샷 / 퓨샷 프롬프트',
  //   description: '입출력 예시(1개 또는 복수)를 제공하여 AI가 패턴을 학습한 뒤 그에 맞춰 응답하도록 유도합니다.',
  //   examplePrompt: '당신은 영화 전문가로서 영화에 대한 요약을 5가지 이모티콘으로 표현해야 합니다.\n' +
  //       '\n' +
  //       'Input: 어벤저스  \n' +
  //       'Output: 🦸‍♂️🧠🧤💥🌍  \n' +
  //       '설명:  \n' +
  //       '🦸‍♂️ – 히어로 총출동  \n' +
  //       '🧠 – 토니 스타크의 두뇌 플레이  \n' +
  //       '🧤 – 인피니티 건틀렛 (타노스의 손)  \n' +
  //       '💥 – 전 우주급 전투  \n' +
  //       '🌍 – 지구의 운명이 걸린 싸움\n' +
  //       '\n\n' +
  //       '🧪 실습:\n' +
  //       'Input: 기생충  \n' +
  //       'Output: ?'
  // },
  {
    title: 'Chain-of-Thought',
    description: 'AI가 중간 사고 과정을 단계적으로 서술하도록 유도해 복잡한 문제에 대한 해결 흐름을 관찰합니다.',
    examplePrompt: '초등학생에게 "생성형AI란 무엇인가요?"라는 질문에 좋은 답변을 만들고 싶어.\n'+
        '\n어떻게 질문을 바꾸고, 답변 흐름을 만들면 좋을지\n'+
        '생각의 흐름에 따라 단계별로 설명해보세요.'
  },
  {
    title: '고무 오리 디버깅',
    description: 'AI가 문제를 해결하기보다 설명을 목적으로 사고 과정을 명확하게 서술하게 유도합니다.',
    examplePrompt: '오리야, 팀원이랑 며칠 전까지만 해도 잘 지냈어.  \n' +
        '그런데 요즘은 내 말에 별 반응도 없고 표정도 예전과는 달라.  \n' +
        '딱히 말 실수를 한 건 없고...\n' +
        '평소대로 말하고 행동한 것 같은데.. \n' +
        '나도 가끔은 개인적인 사유로 팀에서 무슨일이 있냐고 들은적도 있었으니 \n' +
        '개인적으로 무슨 일이 있는걸까? 일이 바빠서 그런가?\n' +
        '나도 점점 팀원과 소원해지는 것 같고.. 걱정이네\n' +
        '내가 혹시 뭘 놓쳤을까?'
  },
  {
    title: '템플릿 기반 프롬프트',
    description: '일정한 포맷(구조화된 질문 양식)을 기반으로 응답을 유도하여 일관된 출력 형식을 받습니다.',
    examplePrompt: '다음 양식에 맞춰 회의록을 정리해 주세요:\n- 제목:\n- 참석자: OOO, OOO, ...\n- 주요 안건:\n- 결정사항:\n\n' + '일자 : 2025.04.23\n' +
        '참여자: 영식, 영철, 옥순, 영자\n\n' +
        '회사 임직원들 AI리터러시 교육 시 어떻게 하면 학습효과? -> 실습 제공 -> 어떤방식으로?\n' +
        '영상 페이지에 LLM 탑재 가능? 탑재가능하다면..\n' +
        '생성형AI 각 프롬프트에 대한 개념 학습 후 실제로 해당 프롬프트를 해볼 수 있으면 좋을듯.\n' +
        '프롬프팅에 익숙하지 못한 직원들을 위해 예시 프롬프트를 자동으로 기입해주는 기능 필요\n' +
        '뻔한 내용이 아닌 뭔가 흥미로운 내용으로 구성해야 학습 참여 유도 가능할듯\n'
  },
  {
    title: '제약 조건 프롬프트',
    description: '출력 길이, 형식, 언어, 단어 수 등 특정 조건을 명시해 AI의 응답 범위를 제어합니다.',
    examplePrompt: '부서회식을 할 예정이야\n' +
        '일자, 시간, 장소 모두 정해졌고 참석자도 확정된 상태야.\n' +
        '단톡방에 공지해야 하는데 뭔가 뻔한 내용말고\n' +
        '위트있고 유머러스하게 해당 내용을 공지하고싶어!\n' +
        '내가 부서에서 막내니깐 예의없는 말은 금지! 500자이내로 작성해줘.'
  },
  {
    title: '연습문제1',
    description: '대출 상품 제안서 작성',
    examplePrompt: '1: 대출 상품 제안서 작성\n' +
        '• 가정: 행원으로서, 고객에게 당행의 신규 대출 상품을 소개하는 제안서를 만들려 합니다. 어떻게 프롬프트를 작성해야 할까요?\n' +
        '• 역할 기반 프롬프트를 이럴 때 사용합니다. AI가 어떤 역할을 해야 하는지 정의한 후, 구체적인 요구 사항을 써주세요.\n' +
        '• 새로운 대화를 시작할 때 언제든 이렇게 시작하면 답변의 품질이 크게 좋아질 수 있습니다.\n' +
        '• 다음의 프롬프트를 참고하여, 프로젝트 제안서의 초안을 한 번 만들어보세요.\n\n' +
        '당신은 경험 많은 금융 기관 직원입니다. 아래 상황을 참고하여, 고객에게 신규 대출 상품을 소개하는 제안서를 작성해 주세요.\n\n' +
        '상황:\n' +
        '• 대출 상품명: "스마트 대출 플랜"\n' +
        '• 주요 특징: 낮은 이자율, 유연한 상환 조건, 간편한 온라인 신청 절차\n' +
        '• 혜택: 첫 6개월 이자 면제, 특별 할인 혜택 제공\n' +
        '• 유의 사항: 신용 등급 및 소득에 따라 대출 한도가 달라질 수 있음\n' +
        '제안서는 공식적이고 이해하기 쉬운 문체로 작성되며, 고객의 관심을 유도할 수 있도록 명확한 구조와 설득력 있는 내용을 포함해 주세요.\n'
  },
  {
    title: '연습문제2',
    description: '원하는 형식으로 답변 얻기',
    examplePrompt: '입력: "지난 회의에서 영업팀은 신규 고객 확보 전략, 마케팅 캠페인 강화, 그리고 경쟁사 분석에 대해 논의했습니다. 회의 결과, 고객 접촉 빈도를 높이고 마케팅 예산을 15% 증액하기로 결정했습니다.“ \n\n' +
        '출력: "회의 요약:\n' +
        '• 논의 주제: 신규 고객 확보 전략, 마케팅 강화, 경쟁사 분석\n' +
        '• 결정 사항: 고객 접촉 빈도 증가, 마케팅 예산 15% 증액“\n\n' +
        '이제, 아래 회의록 내용을 간략하게 요약해 주세요: ' + '"이번 분기 주요 회의에서, 팀은 제품 개선 아이디어와 고객 피드백 분석, 그리고 판매 촉진 방안에 대해 논의했습니다. 결과적으로, 제품 기능 업데이트와 고객 대상 프로모션 실시가 결정되었습니다."\n'
  },
  {
    title: '연습문제3',
    description: '단계를 거쳐 AI가 답하도록 유도하기',
    examplePrompt: '• 당신은 금융 혁신 프로젝트 매니저로서 팀 미팅을 진행하고, 이후 Microsoft Word를 이용해 회의록과 실행 계획서를 작성해야 합니다.\n' +
        '• 신규 프로젝트의 실행 계획을 마련하기 위해, 아이디어 도출부터 구체적인 실행 전략 수립까지의 사고 과정을 단계별로 기록하고 최종 결과를 요약합니다.\n' +
        '• 다음의 프롬프트를 참고하여 상위 리더에게 보고할 프로젝트 진행 계획을 만들어보세요.\n\n' +
        '당신은 경험 많은 프로젝트 매니저입니다. 다음 과정을 단계별로 설명하면서, 최종적으로 신규 프로젝트 실행 계획을 수립해 주세요.\n\n' +
        '1.프로젝트 개요 파악: \n' +
        'o 프로젝트의 목표와 주요 요구사항을 분석합니다.\n' +
        'o 관련 이해관계자 및 리소스를 파악합니다.\n' +
        '2.회의 목표 설정: \n' +
        'o 팀 미팅의 목적과 기대 결과를 정의합니다.\n' +
        'o 핵심 토론 주제와 질문 목록을 도출합니다.\n' +
        '3.사전 준비 및 조사: \n' +
        'o 필요한 자료와 데이터, 이전 유사 사례를 수집합니다.\n' +
        'o 분석한 정보를 바탕으로 문제점과 기회를 식별합니다.\n' +
        '4.아이디어 도출 및 실행 전략 수립: \n' +
        'o 팀원들과의 브레인스토밍 결과를 정리합니다.\n' +
        'o 도출된 아이디어를 우선순위에 따라 분류하고, 실행 가능한 전략을 제안합니다.\n' +
        '5.최종 실행 계획 요약: \n' +
        'o 각 단계를 종합하여 구체적인 실행 계획과 일정, 책임자를 명시합니다.\n' +
        'o 기대 효과와 위험 요인을 함께 기술합니다.\n' +
        '각 단계에서 당신의 생각의 흐름을 명확히 드러내고, 논리적인 이유와 분석 과정을 포함해 주세요.\n'
  }
];

const selectedMissionIndex = ref(null);

const toggleMission = (i) => {
  selectedMissionIndex.value = (selectedMissionIndex.value === i) ? null : i;
}

const currentMission = computed(() =>
    selectedMissionIndex.value !== null ? missions[selectedMissionIndex.value] : null
);



const textarea = ref(null);

const applyExamplePrompt = () => {
  if (currentMission.value) {
    userInput.value = currentMission.value.examplePrompt;
    nextTick(()=>{
      handleInput();
    });
  }
};


const emit = defineEmits(['update:visible', 'done', 'practice-off']);

const store = useStore();

const userInput = ref('');
const messages = ref([]);
const isLoading = ref(false);
const chatContainer = ref(null);

const isVisible = computed({
  // get: () => props.visible,
  get: () => {
    if(!props.visible) return false;
    const now = new Date();
    const currentHour = now.getHours();
    return props.time.includes(currentHour);
  },
  set: (value) => emit('update:visible', value)
});

// 비디오 재생 -> timeupdate 발생 -> point 근접 -> checkPracticePoints 발생 -> AI_PRACTICE_POINTS 에서 해당 시간대 포인트 get
// praticePoint 이벤트 발생 -> 모달열리면서 practicePoint prop 변경 -> 모달의 watch가 실행
// watch(() => props.practicePoint, (newPoint) => {
//   if (newPoint) {
//     messages.value = [{
//       role: 'assistant',
//       content: newPoint.notice
//     }];
//   }
// }, { immediate: true });

const firstSubmitConfirmed = ref(false);

const handleSubmit = async () => {

  if (!userInput.value.trim() || isLoading.value) return;

  // 첫 입력 시 경고
  if (!firstSubmitConfirmed.value){
    const confirmed = window.confirm(
        '개인정보(이름, 주민번호, 연락처 등) 또는 \n회사 내부 정보는 입력하지 마십시오.\n\n위반 시 정보보호 정책에 따라 제재를 받을 수 있습니다.'
    );
    if (!confirmed) return;
    firstSubmitConfirmed.value = true;
  }

  // 개인정보 검사
  const personalInfoPatterns = [
    /\d{6}\d{7}/, // 주민등록번호 (하이픈 없음)
    /\d{6}[\s-]+\d{7}/, // 휴대전화번호 (공백, 하이픈 포함)
    /\d{6}-\d{7}/, // 주민등록번호
    /\d{3}-\d{3,4}-\d{4}/, // 휴대전화번호
    /\d{3}[\s-]+\d{3,4}[\s-]+\d{4}/, // 휴대전화번호 (공백, 하이픈 포함)
    /\d{3}\d{3,4}\d{4}/, // 휴대전화번호 (하이픈 없음)
  ];

  const containsPersonalInfo = personalInfoPatterns.some(pattern =>
      pattern.test(userInput.value)
  );

  if (containsPersonalInfo) {
    messages.value.push({
      role: 'system',
      content: '⚠️개인정보(주민등록번호, 휴대전화번호)가 포함된 질문은 제한됩니다.\n\n다른 주제로 질문해 주세요 😊'
    });
    return;
  }

  // 코드 관련 검사
  const codeInfoPatterns = [
    /소스\s*코드/i,
    /코드\s*분석/i,
    /코드\s*리뷰/i,
    /파이썬.*코드/i,
    /java.*코드/i,
    /코드.*설명해/i,
    /코드.*알려줘/i,
    /function\s+\w+\s*\(.*\)/i, // JS 함수 선언
    /def\s+\w+\s*\(.*\):/i, // Python 함수
    /class\s+\w+/i, // 클래스 선언
    /#include\s*</i, // C/C++
    /public\s+(class|static|void)/i // Java
  ];

  const containsCodeInfo = codeInfoPatterns.some(pattern =>
      pattern.test(userInput.value)
  );

  if (containsCodeInfo) {
    messages.value.push({
      role: 'system',
      content: '⚠️ 소스코드 요청이나 코드 분석 질문은 본 실습 환경에서 지원하지 않습니다.\n\n다른 주제로 질문해 주세요 😊'
    });
    return;
  }


  const question = userInput.value;

  messages.value.push({
    role: 'user',
    // content: question
    content : question.replace(/\n/g, '<br>')
  });
  userInput.value = '';
  isLoading.value = true;




  //예시 프롬프트 설명 패널 닫기
  selectedMissionIndex.value = null;

  try {
    const response = await ApiService.post('/v1/app/llm/practice', {
      question,
      lrnerId : store.state.auth.session?.lrnerId
    });

    console.log('API Response:', response);

    // 응답 구조 확인
    if (!response?.response?.response?.answer) {
      console.error('Invalid response structure:', response);
      throw new Error('Invalid response structure');
    }

    const answer = response.response.response.answer;


    messages.value.push({
      role: 'assistant',
      // content: answer
      content: answer.replace(/\n/g,'<br>')
    });
  } catch (error) {
    console.error('API Error:', error);
    console.error('Error response:', error.response);

    //429 (Too Many Requests) 에러 처리
    if (error.response?.status === 429){
      messages.value.push({
        role: 'system',
        content: '현재 서버가 혼잡합니다. 잠시 후 다시 시도해주세요.'
      });
    } else {
      messages.value.push({
        role: 'system',
        content: '오류가 발생했습니다. 다시 시도해주세요.'
      });
    }
  } finally {
    isLoading.value = false;
  }

  // 호출하고나서 크기 조절
  handleInput();
};

const handleComplete = () => {
  try {
    // emit('done');
    emit('practice-off');
    isVisible.value = false;
  } catch (error) {
    console.error('Error handling practice completion:', error);
  }
  messages.value = [];
  userInput.value = '';
};

const handleClose = () => {
  if (confirm('실습을 종료하시겠습니까?')) {
    handleComplete();
    // emit('practice-off');
  }
};

const handleInput = () =>{
  nextTick( () => {
    if (textarea.value) {
      textarea.value.style.height = 'auto';
      const newHeight = Math.min(textarea.value.scrollHeight,300);
      textarea.value.style.height = newHeight + 'px';
    }
  });
};

// 데스크톱용
// const handleKeydown = (event) => {
//   if(event.shiftKey){
//     //Shift + Enter : 줄바꿈
//     const start = event.target.selectionStart;
//     const end = event.target.selectionEnd;
//     const value = event.target.value;
//     event.target.value = value.substring(0,start) + '\n' + value.substring(end);
//     event.target.selectionStart = event.target.selectionEnd = start + 1;
//     handleInput();
//   } else {
//     //Enter만 : 제출
//     handleSubmit();
//   }
// }


// Scroll to bottom when new messages arrive
watch(() => messages.value.length, () => {
  if (chatContainer.value) {
    setTimeout(() => {
      chatContainer.value.scrollTop = chatContainer.value.scrollHeight;
    }, 0);
  }
});

const sideMenuOpen = ref(false);
const handlePromptSelect = (prompt) => {
  userInput.value = prompt
  sideMenuOpen.value = false
}

const handelContentClick = () => {
  if (sideMenuOpen.value) {
    sideMenuOpen.value = false;
  }
};


watch (
    () => props.visible,
    (val) => {
      if(val) {
        document.body.classList.add('modal-open');
      }else {
        document.body.classList.remove('modal-open');
      }
    }
);

onUnmounted(()=>{
  document.body.classList.remove('modal-open');
});

// 스와이프 기능
let startX = 0;
let touchStartedInCarousel = false;

const onTouchStart = (e) => {
  startX = e.touches[0].clientX;
  touchStartedInCarousel = !!e.target.closest('.mission-tabs-mobile'); // ✅ 올바르게 true/false
};

const onTouchEnd = (e) => {
  const endX = e.changedTouches[0].clientX;
  const diff = endX - startX;

  if (touchStartedInCarousel) {
    // 캐러셀 안에서 시작된 스와이프는 사이드바 무시
    return;
  }

  if (diff > 50) {
    sideMenuOpen.value = true; // 오른쪽으로 스와이프 → 사이드바 열기
  } else if (diff < -50) {
    sideMenuOpen.value = false; // 왼쪽으로 스와이프 → 사이드바 닫기
  }
};

onMounted(() => {
  document.addEventListener('touchstart', onTouchStart);
  document.addEventListener('touchend', onTouchEnd);
});
onUnmounted(() => {
  document.removeEventListener('touchstart', onTouchStart);
  document.removeEventListener('touchend', onTouchEnd);
});


/*
// 스와이프 기능 추가
let startX = 0;
let endX = 0;
const onTouchStart = (e) => { startX = e.touches[0].clientX; };
const onTouchEnd = (e) => {
  endX = e.changedTouches[0].clientX;
  const diff = endX - startX;
  if (diff > 50) sideMenuOpen.value = true;       // 오른쪽으로 스와이프
  else if (diff < -50) sideMenuOpen.value = false; // 왼쪽으로 스와이프
};
onMounted(() => {
  document.addEventListener('touchstart', onTouchStart);
  document.addEventListener('touchend', onTouchEnd);
});
onUnmounted(() => {
  document.removeEventListener('touchstart', onTouchStart);
  document.removeEventListener('touchend', onTouchEnd);
});
*/


</script>


<style scoped>
.modal-overlay-mobile {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/*
.modal-container-mobile {
  display: flex;
  //flex-direction: column;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0; left: 0;
  background: #fff;
  //transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
  //will-change: transform;
  //z-index : 10000;
  //overflow : visible
  overflow: hidden;
}
*/

.modal-container-mobile {
  display: flex;
  flex-direction : column;
  width: 100vw;
  height: 100vh;
  background: #fff;
  position: fixed;
  top: 0; left: 0;
  overflow: hidden;
  z-index: 10000;
}

.menu-wrapper {
  position : absolute;
  top:0;
  left:0;
  width:70vw;
  height:100%;
  background:white;
  z-index:10001;
  transform: translateX(-100%);
  transition : transform 0.3s ease;
}

.content-wrapper {
  display : flex;
  flex-direction : column;
  height: 100dvh;
  position : relative;
  width: 100vw;
  transition : transform 0.3s ease;
  z-index : 1;
}

/*
.content-wrapper {
  display: flex;
  width : 100%;
  max-width : 100vw;
  box-sizing : border-box;
  flex-direction: column;
  height: 100dvh;
  position: relative;
}
*/


.chat-scrollable {
  flex: 1 1 auto;
  overflow-y : auto;
  -webkit-overflow-scrolling : touch;
}

.input-container-mobile {
  width: 100%;
  box-sizing : border-box;
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid #eee;
  padding: 1rem;
}


/* 메뉴 열림 시 적용 */
.menu-open .menu-wrapper {
  transform : translateX(0);
}

.menu-open .content-wrapper {
  transform: translateX(70vw);
}

.menu-open {
  touch-action : none;
  overscroll-behavior : contain;
}


.modal-header-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #ffbc00;
  height: 50px;
}
.hamburger {
  background: transparent;
  border: none;
  font-size: 1.7rem;
  color: #222;
  padding: 0.3rem 0.7rem 0.3rem 0;
  cursor: pointer;
  margin-right: 0.5rem;
}
.modal-header-mobile h3 {
  flex: 1;
  text-align: left;
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.2;
}
.close-button {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #64748b;
  padding: 0.5rem;
  cursor: pointer;
}

.modal-body-mobile {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow : hidden;
}

.modal-content-mobile {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.mission-panel-mobile {
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
}

.mission-tabs-mobile {
  display: flex;
  overflow-x: auto;
  gap: 0.5rem;
  color: #374151;
  //padding-bottom: 0.5rem;
  //-webkit-overflow-scrolling: touch;
  white-space : nowrap;
}

.mission-tabs-mobile label {
  background : #f1f5f9;
  color: #334155;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  white-space : nowrap;
  font-size : 0.9rem;
  border: 1px solid #e2e8f0;
}

.mission-tabs-mobile label.selected {
  background: #3b82f6;
  color: white;
  border-color: #2563eb;
}

.mission-tabs-mobile input[type="radio"] {
  display: none;
}

/*
.mission-tabs-mobile input[type="radio"]:checked + label {
  background: #3b82f6;
  color: white;
  border-color: #2563eb;
}
*/

.mission-desc-mobile {
  background: #ffffff;
  padding: 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-size: 0.92rem;
  color: #374151;
  line-height: 1.6;
  margin-top: 0.75rem;
  overflow-y : auto;
  -webkit-overflow-scrolling : touch;
  max-height : 500px;

}
.mission-desc-mobile p {
  margin-bottom: 0.5rem;
}
.mission-desc-mobile code {
  display: block;
  background: #f3f4f6;
  padding: 0.6rem;
  border-radius: 0.4rem;
  font-size: 0.85rem;
  white-space: pre-wrap;
  color: #1f2937;
}
.mission-desc-mobile button {
  background-color: #6366f1;
  color: white;
  border: none;
  border-radius: 0.375rem;
  padding: 0.4rem 0.9rem;
  margin-top: 0.7rem;
  font-weight: 500;
  transition: background-color 0.2s;
  cursor: pointer;
}
.mission-desc-mobile button:hover {
  background-color: #4f46e5;
}

.chat-panel-mobile {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.chat-container-mobile {
  display : flex;
  flex-direction: column;
  padding: 1rem;
}

/* 자동 스크롤 안돼서 수정
.chat-container-mobile {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 1rem;
}
*/

.message {
  margin-bottom: 1rem;
  max-width: 85%;
}

.message.user {
  margin-left: auto;
}
.message-content {
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  font-size: 0.9375rem;
  line-height: 1.5;
  overflow:hidden;
}
.message.user .message-content {
  background: #3b82f6;
  color: white;
}

.message.assistant .message-content {
  background: #f1f5f9;
  color: #334155;
}
.message.system .message-content {
  background: #fee2e2;
  color: #991b1b;
  font-size: 0.875rem;
}
textarea {
  width: 100%;
  box-sizing : border-box;
  max-width : 100%;
  min-height: 80px;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  resize: none;
  overflow-y : auto;
  font-size: 0.9375rem;
  line-height: 1.5;
}

.button-group-mobile {
  display: flex;
  flex-direction : row;
  gap: 0.5rem;
  width : 100%;
  margin-top: 0.75rem;
  box-sizing: border-box;
}
.button-group-mobile button {
  flex: 1 1 0;
  padding: 0.75rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.9375rem;
}
.submit-button {
  background: #3b82f6;
  color: white;
}
.complete-button {
  background: #10b981;
  color: white;
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 480px) {
  .modal-header-mobile h3 {
    font-size: 1.2rem;
  }
  .message-content {
    font-size: 0.875rem;
  }
  textarea {
    font-size: 0.875rem;
  }
  .button-group-mobile button {
    font-size: 0.875rem;
  }
  .modal-container-mobile { width:100vw; height:100vh;}
  .input-container-mobile { padding : 0.5rem;}
  .side-menu { width:90vw};


  .message-content :deep(h1),
  .message-content :deep(h2),
  .message-content :deep(h3) {
    margin-top : 0.5rem !important;
    margin: 0.5em 0 0.25em;
    font-size: 1rem;
    //font-weight: 600;
    //line-height: 1;
  }

  .message-content :deep(h1) {
    //font-size: 1.75rem;
    border-bottom: 2px solid #e5e7eb;
    //padding-bottom: 0.4em;
  }

  .message-content :deep(h2) {
    //font-size: 1.5rem;
    color: #111827;
  }

  .message-content :deep(h3) {
    //font-size: 1.25rem;
    color: #374151;
  }
  .message-content :deep(h4) {
    //font-size: 1.25rem;
    color: #374151;
  }

  .message-content :deep(p) {
    //margin: 1em 0;
    //line-height: 1.7;
    color: #374151;
    //font-size: 1rem;
  }

  .message-content :deep(strong) {
    font-weight: bold;
    color: #111827;
    //display: block;
    //margin-top: 1em;
    //margin-bottom:0.5em;
  }
}

.example-prompt-btn {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.35rem 1rem;
  font-size: 0.85rem;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(37,99,235,0.08);
}
.example-prompt-btn:hover {
  background: #1d4ed8;
}

/*
.side-menu-open {
  transform : translateX(65vw);
  box-shadow : -8px 0 24px rgba(0,0,0,0.10);
}
*/

.example-prompt-btn.selected {
  background: #3b82f6;
  color:#fff;
  border:1px solid #2563eb;
}

.character-count {
  position : absolute;
  right:1.0rem;
  bottom : 4rem;
  font-size : 0.75rem;
  color: #6b7280;
}

.character-count.near-limit {
  color : #dc2626;
}


</style>

<style>
/*
html, body {
  height : 100%;
  overflow : hidden;
  overscroll-behavior: none;
  touch-action : auto;
}
 */

body.modal-open{
  overflow : hidden;
  height : 100%;
  overscroll-bebavior: none;
  touch-action: pan-y;
}
</style>